(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SfrFileDeleteController',SfrFileDeleteController);

    SfrFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'SfrFile'];

    function SfrFileDeleteController($uibModalInstance, entity, SfrFile) {
        var vm = this;

        vm.sfrFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SfrFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
